import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../Components/utils/getToken";

export async function fetchCrmReminderAnalytics(days = 7) {
  const token = decryptToken("accessToken") || "";
  if (!token) return null;

  try {
    const res = await fetch(`${API_BASE_URL}/leads/reminder-analytics?days=${days}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}

export async function logCrmReminderClientEvent({
  leadId,
  eventType,
  channel = "browser",
  phase = null,
  slot = null,
}) {
  const token = decryptToken("accessToken") || "";
  if (!token || !eventType) return false;

  try {
    const res = await fetch(`${API_BASE_URL}/leads/reminder-event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ leadId, eventType, channel, phase, slot }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
